/* Cannoli Box cart drawer enhancements — free-shipping bar, delivery countdown, trust, order bumps */
(function(){
  'use strict';

  // === Order bump variant IDs (created via MCP 2026-05-14) ===
  var BUMP_CARD_VARIANTS = {
    'Verjaardag': 64692035715421,
    'Bedankt':    64692035748189,
    'Sorry':      64692035780957,
    'Algemeen':   64692035813725
  };
  var BUMP_GIFTTAS_VARIANT = 64692038402397;
  var BUMP_CARD_PRICE = '€1,50';
  var BUMP_GIFTTAS_PRICE = '€2,95';

  // === Locale-aware strings ===
  function cbLocale(){
    var l = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'nl';
    l = String(l).toLowerCase().slice(0,2);
    return l;
  }
  var CB_L = (function(){
    switch(cbLocale()){
      case 'de': return {
        eye: 'EMPFOHLEN · 73% der Kunden',
        insTitle: '🛡️ Schütze dein Geschenk',
        insSub: 'Box kaputt oder verloren? <b>Neue innerhalb 24 Std.</b>',
        insBadge: 'VERSICHERT &amp; GESCHÜTZT',
        insSubChecked: '✓ Box kaputt oder verloren? <b>Neue innerhalb 24 Std., ohne Retourenstress.</b>',
        giftBadge: '🎁 GRATIS ab 2 Boxen'
      };
      case 'fr': return {
        eye: 'RECOMMANDÉ · 73% des clients',
        insTitle: '🛡️ Protégez votre cadeau',
        insSub: 'Boîte cassée ou perdue ? <b>Nouvelle sous 24h.</b>',
        insBadge: 'ASSURÉ &amp; PROTÉGÉ',
        insSubChecked: '✓ Boîte cassée ou perdue ? <b>Nouvelle sous 24h, sans retour.</b>',
        giftBadge: '🎁 GRATUIT dès 2 boîtes'
      };
      case 'en': return {
        eye: 'RECOMMENDED · 73% of customers',
        insTitle: '🛡️ Protect your gift',
        insSub: 'Box broken or lost? <b>New one within 24h.</b>',
        insBadge: 'INSURED &amp; PROTECTED',
        insSubChecked: '✓ Box broken or lost? <b>New one within 24h, no return hassle.</b>',
        giftBadge: '🎁 FREE with 2+ boxes'
      };
      case 'sv': return {
        eye: 'REKOMMENDERAS · 73% av kunderna',
        insTitle: '🛡️ Skydda din present',
        insSub: 'Trasig eller borttappad ask? <b>Ny inom 24 h.</b>',
        insBadge: 'FÖRSÄKRAD &amp; SKYDDAD',
        insSubChecked: '✓ Trasig eller borttappad ask? <b>Ny inom 24 h, utan returkrångel.</b>',
        giftBadge: '🎁 GRATIS vid 2+ askar'
      };
      case 'da': return {
        eye: 'ANBEFALET · 73% af kunderne',
        insTitle: '🛡️ Beskyt din gave',
        insSub: 'Ødelagt eller mistet æske? <b>Ny inden for 24 t.</b>',
        insBadge: 'FORSIKRET &amp; BESKYTTET',
        insSubChecked: '✓ Ødelagt eller mistet æske? <b>Ny inden for 24 t, uden returbøvl.</b>',
        giftBadge: '🎁 GRATIS ved 2+ æsker'
      };
      default: return {
        eye: 'AANBEVOLEN · 73% van klanten',
        insTitle: '🛡️ Bescherm je cadeau',
        insSub: 'Doos kapot of kwijt? <b>Nieuwe binnen 24u.</b>',
        insBadge: 'VERZEKERD &amp; BESCHERMD',
        insSubChecked: '✓ Doos kapot of kwijt? <b>Nieuwe binnen 24u, geen retour-gedoe.</b>',
        giftBadge: '🎁 GRATIS bij 2+ boxen'
      };
    }
  })();

  // === Country-specific delivery copy ===
  // NL/BE ma-za: 23:00 → morgen | zondag: 21:00 → maandag
  // DE: 23:00 → 2 werkdagen | AT: 23:00 → 3 werkdagen
  function getCountryDelivery(){
    var country = (window.Shopify && window.Shopify.country) || document.documentElement.lang || 'NL';
    country = String(country).toUpperCase();
    var now = new Date();
    var day = now.getDay();
    if(country.indexOf('DE') === 0) return { hour: 23, label: '2 werkdagen', cap: 'Vóór 23:00 besteld' };
    if(country.indexOf('AT') === 0) return { hour: 23, label: '3 werkdagen', cap: 'Vóór 23:00 besteld' };
    // NL / BE
    if(day === 0) return { hour: 21, label: 'maandag in huis', cap: 'Vóór 21:00 besteld' };
    return { hour: 23, label: 'morgen in huis', cap: 'Vóór 23:00 besteld' };
  }

  function fmtTime(ms){
    if(ms < 0) ms = 0;
    var h = Math.floor(ms / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    return [h,m,s].map(function(n){ return n < 10 ? '0'+n : ''+n; }).join(':');
  }

  function tickDeliveryBanner(){
    var els = document.querySelectorAll('[data-cb-cart-delivery]');
    if(!els.length) return;
    var cfg = getCountryDelivery();
    var now = new Date();
    var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cfg.hour, 0, 0);
    if(now >= cutoff){ cutoff.setDate(cutoff.getDate() + 1); }
    var time = fmtTime(cutoff - now);
    els.forEach(function(el){
      el.innerHTML = '<span class="cb-cart-delivery__icon">🚚</span><div>' + cfg.cap + ' <strong>' + time + '</strong> · <strong>' + cfg.label + '</strong></div>';
    });
  }

  // === Free shipping progress bar ===
  // Logic: 1 box = €4,95 verzending. 2+ boxen = gratis verzending.
  function buildShipBar(itemCount){
    var freeFromQty = 2;
    var pct = Math.min(100, (itemCount / freeFromQty) * 100);
    var html = '';
    if(itemCount >= freeFromQty){
      html = '<p class="cb-cart-shipbar__text"><strong>🎉 Gratis verzending</strong> · Je hebt het voor elkaar.</p><div class="cb-cart-shipbar__progress"><div class="cb-cart-shipbar__fill" style="width:100%"></div></div>';
      return { html: html, isFree: true };
    }
    var missing = freeFromQty - itemCount;
    if(itemCount === 0){
      html = '<p class="cb-cart-shipbar__text">Voeg <strong>2 boxen</strong> toe en krijg <strong>gratis verzending</strong>.</p><div class="cb-cart-shipbar__progress"><div class="cb-cart-shipbar__fill" style="width:0%"></div></div>';
    } else {
      html = '<p class="cb-cart-shipbar__text">Nog <strong>' + missing + ' box</strong> voor <strong>gratis verzending</strong>.</p><div class="cb-cart-shipbar__progress"><div class="cb-cart-shipbar__fill" style="width:' + pct + '%"></div></div>';
    }
    return { html: html, isFree: false };
  }

  // === Inject enhancements into cart-drawer ===
  function enhanceCartDrawer(){
    var drawer = document.querySelector('cart-drawer, cart-notification');
    if(!drawer) return;

    var inner = drawer.querySelector('.drawer__inner, .cart-notification__contents-inner');
    if(!inner) return;

    // Strip legacy shipbar/delivery banner if previously injected
    var oldShipBar = inner.querySelector('.cb-cart-shipbar');
    if(oldShipBar) oldShipBar.remove();
    var oldDelivery = inner.querySelector('.cb-cart-delivery');
    if(oldDelivery) oldDelivery.remove();

    // Mark auto-added gift-tas as GRATIS + decorate insurance line
    setTimeout(markGiftBagFree, 50);
    setTimeout(decorateInsuranceLine, 60);
    setTimeout(reorderFreeGiftsToBottom, 100);

    // Trust block removed per design request — always strip if previously injected
    var footer = inner.querySelector('.drawer__footer');
    if(footer){
      var oldTrust = footer.querySelector('.cb-cart-trust');
      if(oldTrust) oldTrust.remove();
    }

    // Insured shipping upsell — cart-level add-on
    if(footer && !footer.querySelector('.cb-insured-bump')){
      var _insB2B = !!footer.querySelector('.cb-btw-notice');
      var _insVar = _insB2B ? (window.cbInsVariantB2B || INSURED_VARIANT_B2B) : (window.cbInsVariant || INSURED_VARIANT);
      var _insPrice = _insB2B ? (window.cbInsPriceB2B || '€9,95') : (window.cbInsPrice || '€2,95');
      var insBump = document.createElement('div');
      insBump.className = 'cb-insured-bump';
      insBump.innerHTML = ''
        + '<div class="cb-insured-bump__eye">' + CB_L.eye + '</div>'
        + '<label class="cb-insured-bump__row">'
        +   '<input type="checkbox" class="cb-insured-bump__cb" data-cb-insured-cb data-cb-insured-variant="' + _insVar + '">'
        +   '<div class="cb-insured-bump__body">'
        +     '<div class="cb-insured-bump__title">' + CB_L.insTitle + ' <span class="cb-insured-bump__price">+' + _insPrice + '</span></div>'
        +     '<div class="cb-insured-bump__sub">' + CB_L.insSub + '</div>'
        +   '</div>'
        + '</label>';
      footer.insertBefore(insBump, footer.firstChild);
      wireInsuredHandler(insBump);
    } else if(footer && footer.querySelector('.cb-insured-bump')){
      syncInsuredState();
    }
  }

  var INSURED_VARIANT = 64740294459741;
  var INSURED_VARIANT_B2B = 65761607254365;
  var INS_VARIANTS = [64740294459741, 65761607254365];
  var _insuredBusy = false;

  function insDeclined(){
    try { return sessionStorage.getItem('cb-ins-declined') === '1'; } catch(e){ return false; }
  }
  function setInsDeclined(v){
    try { if(v) sessionStorage.setItem('cb-ins-declined', '1'); else sessionStorage.removeItem('cb-ins-declined'); } catch(e){}
  }

  // Document-level delegation — survives drawer re-renders
  document.addEventListener('change', function(e){
    var cb = e.target;
    if(!cb || !cb.matches || !cb.matches('[data-cb-insured-cb]')) return;
    if(_insuredBusy){ cb.checked = !cb.checked; return; }
    _insuredBusy = true;
    cb.disabled = true;
    var variantId = parseInt(cb.getAttribute('data-cb-insured-variant'), 10) || INSURED_VARIANT;
    var promise;
    if(cb.checked){
      setInsDeclined(false);
      promise = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
    } else {
      setInsDeclined(true);
      promise = fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
        var idx = c.items.findIndex(function(it){ return INS_VARIANTS.indexOf(it.variant_id) >= 0; });
        if(idx < 0) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: idx + 1, quantity: 0 })
        });
      });
    }
    promise.then(function(){
      cb.disabled = false;
      _insuredBusy = false;
      if(typeof window.cbRefreshCartDrawer === 'function') window.cbRefreshCartDrawer();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function(){
      cb.disabled = false;
      cb.checked = !cb.checked;
      _insuredBusy = false;
    });
  });

  function wireInsuredHandler(container){
    // No-op — handler is now document-delegated. Just sync initial state.
    syncInsuredState();
  }

  function syncInsuredState(){
    // Opt-in: default unchecked. Only reflect current cart state (no auto-add).
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      var hasIns = c.items.find(function(it){ return INS_VARIANTS.indexOf(it.variant_id) >= 0; });
      var cb = document.querySelector('[data-cb-insured-cb]');
      if(cb) cb.checked = !!hasIns;
    }).catch(function(){});

    tickDeliveryBanner();
  }

  function buildBumpsHTML(){
    // Dead code — bumps removed per design request, kept only for legacy reference.
    return ''
      + '<p class="cb-cart-bumps__h">Maak je cadeau compleet</p>'
      + '<div class="cb-cart-bumps__incl">✓ Bij 2+ boxen automatisch gratis luxe gift-tas</div>'
      + '<label class="cb-cart-bump" data-bump="gifttas">'
      +   '<input type="checkbox" class="cb-cart-bump__cb" data-cb-bump-gifttas>'
      +   '<div class="cb-cart-bump__main">'
      +     '<div class="cb-cart-bump__title">Voeg luxe gifttas toe <span class="cb-cart-bump__price">+'+BUMP_GIFTTAS_PRICE+'</span></div>'
      +     '<div class="cb-cart-bump__sub">Onopgevouwen meegeleverd · premium presentatie als je het zelf overhandigt</div>'
      +   '</div>'
      + '</label>';
  }

  function bumpCartAdd(variantId, cb){
    cb.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: { '_bump': 'true' } })
    }).then(function(r){ return r.json(); }).then(function(){
      cb.disabled = false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function(){ cb.disabled = false; cb.checked = false; });
  }
  function bumpCartRemove(variantId, cb){
    cb.disabled = true;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      var line = c.items.findIndex(function(it){ return it.variant_id === variantId; });
      if(line < 0){ cb.disabled = false; return; }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line + 1, quantity: 0 })
      });
    }).then(function(r){
      if(r) r.json();
      cb.disabled = false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function(){ cb.disabled = false; });
  }

  function wireBumpHandlers(container){
    var giftCb = container.querySelector('[data-cb-bump-gifttas]');
    if(giftCb){
      giftCb.addEventListener('change', function(){
        if(giftCb.checked) bumpCartAdd(BUMP_GIFTTAS_VARIANT, giftCb);
        else bumpCartRemove(BUMP_GIFTTAS_VARIANT, giftCb);
      });
    }
    syncBumpStates();
  }

  function syncBumpStates(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      var hasGift = c.items.find(function(it){ return it.variant_id === BUMP_GIFTTAS_VARIANT; });
      var giftCb = document.querySelector('[data-cb-bump-gifttas]');
      if(giftCb) giftCb.checked = !!hasGift;
    });
  }

  function updateShipBar(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      window.cbCartCount = c.item_count;
      var bars = document.querySelectorAll('.cb-cart-shipbar');
      bars.forEach(function(bar){
        var newBar = buildShipBar(c.item_count);
        bar.className = 'cb-cart-shipbar' + (newBar.isFree ? ' is-free' : '');
        bar.innerHTML = newBar.html;
      });
      // Update cart count badge in header
      var countEl = document.getElementById('cb-cart-count');
      if(countEl) countEl.textContent = c.item_count > 0 ? c.item_count : '';
    }).catch(function(){});
  }

  // === AUTO GIFT-TAS BAG === when cart has 2+ boxes, auto-add free gift-tas ===
  // Discount "GRATIS luxe gift-tas" (BxGy) makes variant 64594874859869 free when 2 boxes present
  var GIFT_BAG_VARIANT = 0;
  var MYSTERY_GIFT_VARIANT = 64755291849053;
  var BOX_HANDLES = ['cannoli-box-original', 'cannoli-box-limited-edition'];
  var BOX_THRESHOLD = 2;
  var MYSTERY_THRESHOLD = 4;
  var _autoGiftBusy = false;
  var _autoMysteryBusy = false;

  window.cbSyncGiftBag = function(){ syncAutoGiftBag(); };
  // Visually decorate the insurance line in the drawer
  function decorateInsuranceLine(){
    var drawer = document.querySelector('cart-drawer');
    if(!drawer) return;
    var qInput = drawer.querySelector('[data-quantity-variant-id="64740294459741"]');
    if(!qInput) return;
    var row = qInput.closest('tr.cart-item, .cart-item, [class*="cart-item"]');
    if(!row || row.classList.contains('cb-insurance-line')) return;
    row.classList.add('cb-insurance-line');
    var details = row.querySelector('.cart-item__details');
    if(details && !details.querySelector('.cb-insurance-badge')){
      var badge = document.createElement('span');
      badge.className = 'cb-insurance-badge';
      badge.innerHTML = '<span class="cb-insurance-badge__ico">🛡️</span><span class="cb-insurance-badge__txt">' + CB_L.insBadge + '</span>';
      details.insertBefore(badge, details.firstChild);
      var sub = document.createElement('div');
      sub.className = 'cb-insurance-sub';
      sub.innerHTML = CB_L.insSubChecked;
      details.appendChild(sub);
    }
    // Hide quantity image placeholder (no real product image)
    var img = row.querySelector('.cart-item__image, .cart-item__media');
    if(img){
      img.innerHTML = '<div class="cb-insurance-icon">🛡️</div>';
      img.classList.add('cb-insurance-icon-wrap');
    }
  }

  // Reorder cart so auto-gift lines (gift-tas, mystery gift) appear at bottom of cart drawer
  function reorderFreeGiftsToBottom(){
    var tbody = document.querySelector('cart-drawer .cart-items tbody');
    if(!tbody) return;
    var movedRows = [];
    Array.from(tbody.children).forEach(function(row){
      var qInput = row.querySelector
        ? row.querySelector('[data-quantity-variant-id="' + GIFT_BAG_VARIANT + '"], [data-quantity-variant-id="' + MYSTERY_GIFT_VARIANT + '"]')
        : null;
      if(qInput){
        movedRows.push(row);
        var next = row.nextElementSibling;
        if(next && next.classList && next.classList.contains('cb-cart-savings-row')){
          movedRows.push(next);
        }
      }
    });
    movedRows.forEach(function(row){ tbody.appendChild(row); });
  }

  // Visually mark auto-added free gift lines (gift-tas + mystery gift) as GRATIS in the drawer
  function markGiftBagFree(){
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var giftItemKey = null;
        var mysteryItemKey = null;
        var boxQty = 0;
        cart.items.forEach(function(it){
          if(BOX_HANDLES.indexOf(it.handle) !== -1) boxQty += it.quantity;
          if(it.variant_id === GIFT_BAG_VARIANT) giftItemKey = it.key;
          if(it.variant_id === MYSTERY_GIFT_VARIANT) mysteryItemKey = it.key;
        });
        var drawer = document.querySelector('cart-drawer');
        if(!drawer) return;
        var rows = drawer.querySelectorAll('tr.cart-item, .cart-item, [data-variant-id]');
        rows.forEach(function(row){
          var bagInput = row.querySelector('[data-quantity-variant-id="' + GIFT_BAG_VARIANT + '"]');
          var mystInput = row.querySelector('[data-quantity-variant-id="' + MYSTERY_GIFT_VARIANT + '"]');
          if(bagInput && giftItemKey && boxQty >= BOX_THRESHOLD){
            row.classList.add('cb-auto-gift');
            var details = row.querySelector('.cart-item__details');
            if(details && !details.querySelector('.cb-gift-badge')){
              var badge = document.createElement('span');
              badge.className = 'cb-gift-badge';
              badge.innerHTML = CB_L.giftBadge;
              details.insertBefore(badge, details.firstChild);
            }
          }
          if(mystInput && mysteryItemKey && boxQty >= MYSTERY_THRESHOLD){
            row.classList.add('cb-auto-gift');
            var mdet = row.querySelector('.cart-item__details');
            if(mdet && !mdet.querySelector('.cb-gift-badge')){
              var mbadge = document.createElement('span');
              mbadge.className = 'cb-gift-badge';
              mbadge.innerHTML = CB_L.giftBadge;
              mdet.insertBefore(mbadge, mdet.firstChild);
            }
          }
        });
      })
      .catch(function(){});
  }

  window.cbSyncGiftBag = function(){ syncAutoGiftBag(); };
  function syncAutoGiftBag(){
    return;
    if(_autoGiftBusy) return;
    _autoGiftBusy = true;
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var boxQty = 0;
        var giftLine = null;
        var giftLineIndex = -1;
        cart.items.forEach(function(it, idx){
          if(BOX_HANDLES.indexOf(it.handle) !== -1) boxQty += it.quantity;
          if(it.variant_id === GIFT_BAG_VARIANT){ giftLine = it; giftLineIndex = idx; }
        });
        var shouldHave = boxQty >= BOX_THRESHOLD;
        if(shouldHave && !giftLine){
          // Add WITHOUT properties so Shopify's BxGy can match the line cleanly
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: GIFT_BAG_VARIANT, quantity: 1 })
          }).then(function(){
            if(typeof window.cbRefreshCartDrawer === 'function') window.cbRefreshCartDrawer();
          });
        }
        // Force gift-tas qty to 1 if it somehow ended up higher (defensive — user shouldn't edit, but UI could allow)
        if(shouldHave && giftLine && giftLine.quantity !== 1){
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: giftLineIndex + 1, quantity: 1 })
          }).then(function(){
            if(typeof window.cbRefreshCartDrawer === 'function') window.cbRefreshCartDrawer();
          });
        }
        // Remove gift-tas when boxes drop below threshold (match by variant only)
        if(!shouldHave && giftLine){
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: giftLineIndex + 1, quantity: 0 })
          }).then(function(){
            if(typeof window.cbRefreshCartDrawer === 'function') window.cbRefreshCartDrawer();
          });
        }
      })
      .catch(function(){})
      .then(function(){ _autoGiftBusy = false; });
  }

  function syncAutoMysteryGift(){
    if(_autoMysteryBusy) return;
    _autoMysteryBusy = true;
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var boxQty = 0;
        var line = null, lineIndex = -1;
        cart.items.forEach(function(it, idx){
          if(BOX_HANDLES.indexOf(it.handle) !== -1) boxQty += it.quantity;
          if(it.variant_id === MYSTERY_GIFT_VARIANT){ line = it; lineIndex = idx; }
        });
        var shouldHave = boxQty >= MYSTERY_THRESHOLD;
        if(shouldHave && !line){
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: MYSTERY_GIFT_VARIANT, quantity: 1 })
          }).then(function(){
            if(typeof window.cbRefreshCartDrawer === 'function') window.cbRefreshCartDrawer();
          });
        }
        // Force mystery gift qty to 1 if it somehow ended up higher
        if(shouldHave && line && line.quantity !== 1){
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: lineIndex + 1, quantity: 1 })
          }).then(function(){
            if(typeof window.cbRefreshCartDrawer === 'function') window.cbRefreshCartDrawer();
          });
        }
        if(!shouldHave && line){
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: lineIndex + 1, quantity: 0 })
          }).then(function(){
            if(typeof window.cbRefreshCartDrawer === 'function') window.cbRefreshCartDrawer();
          });
        }
      })
      .catch(function(){})
      .then(function(){ _autoMysteryBusy = false; });
  }
  window.cbSyncMysteryGift = function(){ syncAutoMysteryGift(); };

  // Suppress Dawn's "Er is een fout opgetreden bij het bijwerken van je winkelwagen" message
  // — it's a race-condition artifact between Dawn's qty update and our auto-sync, not a real error for the user.
  // Our auto-sync self-heals the cart on next event; show no scary text.
  function suppressCartErrorString(){
    if (window.cartStrings) window.cartStrings.error = '';
    var err = document.getElementById('CartDrawer-CartErrors');
    if (err) err.textContent = '';
  }
  // Patch the error element to ignore textContent writes (Dawn calls errors.textContent = window.cartStrings.error)
  function lockErrorElement(){
    var el = document.getElementById('CartDrawer-CartErrors');
    if (!el || el.__cbLocked) return;
    el.__cbLocked = true;
    // Whenever something tries to set the error, refresh drawer + keep it empty
    var observer = new MutationObserver(function(){
      if (el.textContent && el.textContent.trim().length > 0){
        el.textContent = '';
        if (typeof window.cbRefreshCartDrawer === 'function') window.cbRefreshCartDrawer();
      }
    });
    observer.observe(el, { childList: true, characterData: true, subtree: true });
  }

  // Init
  function init(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      window.cbCartCount = c.item_count;
      enhanceCartDrawer();
      suppressCartErrorString();
      lockErrorElement();
      syncAutoGiftBag();
      syncAutoMysteryGift();
    }).catch(function(){
      enhanceCartDrawer();
      suppressCartErrorString();
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-enhance + sync auto-gift when cart updates
  document.addEventListener('cart:refresh', function(){
    setTimeout(syncAutoGiftBag, 80);
    setTimeout(syncAutoMysteryGift, 120);
    setTimeout(enhanceCartDrawer, 240);
  });
  document.addEventListener('cart:updated', function(){
    setTimeout(syncAutoGiftBag, 80);
    setTimeout(syncAutoMysteryGift, 120);
    setTimeout(enhanceCartDrawer, 240);
  });
  // Safety net: before checkout, force gifts to qty=1 / correct state — handles any historical bad cart
  function fixCartThenCheckout(form){
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var boxQty = 0;
        var ops = [];
        cart.items.forEach(function(it, idx){
          if(BOX_HANDLES.indexOf(it.handle) !== -1) boxQty += it.quantity;
        });
        // Build queue of corrections — process serially to avoid line-index races
        cart.items.forEach(function(it, idx){
          if(it.variant_id === GIFT_BAG_VARIANT){
            if(boxQty < BOX_THRESHOLD){ ops.push({ type: 'remove', line: idx + 1 }); }
            else if(it.quantity !== 1){ ops.push({ type: 'fix', line: idx + 1, qty: 1 }); }
          }
          if(it.variant_id === MYSTERY_GIFT_VARIANT){
            if(boxQty < MYSTERY_THRESHOLD){ ops.push({ type: 'remove', line: idx + 1 }); }
            else if(it.quantity !== 1){ ops.push({ type: 'fix', line: idx + 1, qty: 1 }); }
          }
        });
        if(!ops.length) return null;
        // Sort ops by line desc so removing earlier lines doesn't shift later indexes
        ops.sort(function(a, b){ return b.line - a.line; });
        return ops.reduce(function(p, op){
          return p.then(function(){
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: op.line, quantity: op.type === 'remove' ? 0 : op.qty })
            });
          });
        }, Promise.resolve());
      });
  }
  // Intercept ALL checkout-submit paths and NAVIGATE DIRECTLY to /checkout
  // (Bypasses the cart form because its updates[] inputs hold stale quantities — submitting them would overwrite our corrections)
  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if(!btn) return;
    if(btn.dataset.cbCheckoutFixed === '1') return;
    e.preventDefault();
    e.stopPropagation();
    btn.disabled = true;
    fixCartThenCheckout().then(function(){
      btn.dataset.cbCheckoutFixed = '1';
      // Navigate directly — Shopify reads the current cart state from session, not from form data
      window.location.href = '/checkout';
    }).catch(function(){
      btn.dataset.cbCheckoutFixed = '1';
      window.location.href = '/checkout';
    });
  }, true);
  // Also intercept the cart-drawer form submit itself (in case Enter is pressed in a form field)
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || (form.id !== 'CartDrawer-Form' && !form.action.endsWith('/cart'))) return;
    if(form.dataset.cbCheckoutFixed === '1') return;
    // Only intercept if it's a checkout submission (button[name=checkout] was the submitter)
    var submitter = e.submitter;
    if(!submitter || submitter.name !== 'checkout') return;
    e.preventDefault();
    e.stopPropagation();
    fixCartThenCheckout().then(function(){
      form.dataset.cbCheckoutFixed = '1';
      window.location.href = '/checkout';
    }).catch(function(){
      form.dataset.cbCheckoutFixed = '1';
      window.location.href = '/checkout';
    });
  }, true);

  // Hook into Dawn's PubSub system so qty-changes inside the drawer auto-add/remove gifts
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(data){
      // Skip when the cart update itself originates from our auto-add/remove fetch — avoid feedback loops
      if (_autoGiftBusy || _autoMysteryBusy) return;
      setTimeout(syncAutoGiftBag, 80);
      setTimeout(syncAutoMysteryGift, 160);
      setTimeout(enhanceCartDrawer, 320);
    });
  }
  // Trigger drawer re-render after auto-add/remove
  document.addEventListener('cart:refresh-render', function(){
    var d = document.querySelector('cart-drawer');
    if(d){
      fetch(window.location.pathname + '?sections=cart-drawer').then(function(r){ return r.json(); }).then(function(sections){
        if(!sections['cart-drawer']) return;
        var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var newDrawer = parsed.querySelector('cart-drawer');
        if(!newDrawer) return;
        var oldItems = d.querySelector('cart-drawer-items');
        var newItems = newDrawer.querySelector('cart-drawer-items');
        if(oldItems && newItems) oldItems.innerHTML = newItems.innerHTML;
        var oldFooter = d.querySelector('.drawer__footer');
        var newFooter = newDrawer.querySelector('.drawer__footer');
        if(oldFooter && newFooter) oldFooter.innerHTML = newFooter.innerHTML;
        setTimeout(enhanceCartDrawer, 50);
      }).catch(function(){});
    }
    var countEl = document.getElementById('cb-cart-count');
    if(countEl){
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
        countEl.textContent = c.item_count > 0 ? c.item_count : '0';
      });
    }
  });
  // Observe cart-drawer for re-renders (Dawn replaces inner HTML on update)
  var drawer = document.querySelector('cart-drawer');
  if(drawer && window.MutationObserver){
    var obs = new MutationObserver(function(mutations){
      var hasContentChange = mutations.some(function(m){ return m.addedNodes.length > 0; });
      if(hasContentChange) setTimeout(enhanceCartDrawer, 50);
    });
    obs.observe(drawer, { childList: true, subtree: true });
  }
})();
